"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timepicker = exports.WrappedTimepicker = exports.normalizeTime = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var moment_1 = tslib_1.__importDefault(require("moment"));
var util_1 = require("@gooddata/util");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var Dropdown_1 = require("../Dropdown");
var timeUtilities_1 = require("./utils/timeUtilities");
Object.defineProperty(exports, "normalizeTime", { enumerable: true, get: function () { return timeUtilities_1.normalizeTime; } });
var List_1 = require("../List");
var DEFAULT_WIDTH = 199;
var MINUTES_IN_HOUR = 60;
var MAX_VISIBLE_ITEMS_COUNT = 10;
var WrappedTimepicker = /** @class */ (function (_super) {
    tslib_1.__extends(WrappedTimepicker, _super);
    function WrappedTimepicker(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdownRef = react_1.default.createRef();
        _this.getTimeItems = function (selectedTime) {
            var currentItem;
            var items = [];
            var hours = selectedTime.h, minutes = selectedTime.m;
            for (var h = 0; h < timeUtilities_1.HOURS_IN_DAY; h += 1) {
                for (var m = 0; m < MINUTES_IN_HOUR; m += timeUtilities_1.TIME_ANCHOR) {
                    var item = {
                        h: h,
                        m: m,
                        title: timeUtilities_1.formatTime(h, m),
                    };
                    items.push(item);
                    if (h === hours && m === minutes) {
                        currentItem = item;
                    }
                }
            }
            return { items: items, currentItem: currentItem };
        };
        _this.updateDropdownWidth = function () {
            var width = _this.dropdownRef.current.getBoundingClientRect().width;
            _this.setState({ dropdownWidth: width });
        };
        _this.handleTimeChanged = function (newlySelectedTime) {
            if (!newlySelectedTime) {
                return;
            }
            var h = newlySelectedTime.h, m = newlySelectedTime.m;
            var selectedTime = timeUtilities_1.updateTime(h, m);
            _this.setState({ selectedTime: selectedTime }, function () { return _this.props.onChange(selectedTime); });
        };
        _this.updateLocaleForMoment();
        var time = props.time || new Date();
        _this.state = {
            dropdownWidth: DEFAULT_WIDTH,
            selectedTime: props.skipNormalizeTime ? time : timeUtilities_1.normalizeTime(time),
        };
        return _this;
    }
    WrappedTimepicker.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        if (newProps.time !== this.props.time) {
            var updatedTime = newProps.time || new Date();
            this.setState({
                selectedTime: this.props.skipNormalizeTime ? updatedTime : timeUtilities_1.normalizeTime(updatedTime),
            });
        }
    };
    WrappedTimepicker.prototype.componentDidMount = function () {
        this.updateDropdownWidth();
    };
    WrappedTimepicker.prototype.getComponentClasses = function () {
        return "gd-datepicker " + this.props.className + " gd-datepicker-input gd-timepicker";
    };
    WrappedTimepicker.prototype.updateLocaleForMoment = function () {
        moment_1.default.locale(util_1.translationUtils.sanitizeLocaleForMoment(this.props.intl.locale));
    };
    WrappedTimepicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, overlayPositionType = _a.overlayPositionType, maxVisibleItemsCount = _a.maxVisibleItemsCount, overlayZIndex = _a.overlayZIndex;
        var _b = this.state, dropdownWidth = _b.dropdownWidth, selectedTime = _b.selectedTime;
        var time = {
            h: selectedTime.getHours(),
            m: selectedTime.getMinutes(),
        };
        var _c = this.getTimeItems(time), items = _c.items, currentItem = _c.currentItem;
        return (react_1.default.createElement("div", { className: this.getComponentClasses(), ref: this.dropdownRef },
            react_1.default.createElement(Dropdown_1.Dropdown, { overlayPositionType: overlayPositionType, alignPoints: [
                    {
                        align: "bl tl",
                    },
                    {
                        align: "tl bl",
                    },
                ], renderButton: function (_a) {
                    var openDropdown = _a.openDropdown, isOpen = _a.isOpen;
                    return (react_1.default.createElement(Dropdown_1.DropdownButton, { value: timeUtilities_1.formatTime(time.h, time.m), isOpen: isOpen, onClick: openDropdown, iconLeft: "gd-icon-timer" }));
                }, renderBody: function (_a) {
                    var closeDropdown = _a.closeDropdown, isMobile = _a.isMobile;
                    return (react_1.default.createElement(Dropdown_1.DropdownList, { isMobile: isMobile, width: dropdownWidth, items: items, renderItem: function (_a) {
                            var item = _a.item;
                            return (react_1.default.createElement(List_1.SingleSelectListItem, { title: item.title, isSelected: item === currentItem, onClick: function () {
                                    _this.handleTimeChanged(item);
                                    closeDropdown();
                                } }));
                        }, maxVisibleItemsCount: maxVisibleItemsCount }));
                }, overlayZIndex: overlayZIndex })));
    };
    WrappedTimepicker.defaultProps = {
        className: "",
        maxVisibleItemsCount: MAX_VISIBLE_ITEMS_COUNT,
        time: new Date(),
        onChange: noop_1.default,
        overlayZIndex: 0,
        skipNormalizeTime: false,
    };
    return WrappedTimepicker;
}(react_1.default.PureComponent));
exports.WrappedTimepicker = WrappedTimepicker;
var TimePickerWithIntl = react_intl_1.injectIntl(WrappedTimepicker);
/**
 * @internal
 */
var Timepicker = /** @class */ (function (_super) {
    tslib_1.__extends(Timepicker, _super);
    function Timepicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Timepicker.prototype.render = function () {
        return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: this.props.locale },
            react_1.default.createElement(TimePickerWithIntl, tslib_1.__assign({}, this.props))));
    };
    return Timepicker;
}(react_1.default.PureComponent));
exports.Timepicker = Timepicker;
//# sourceMappingURL=Timepicker.js.map